import styles from "./ReviewSection.module.css"
// import styles from "./Slider.css"
import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import photo_1 from "../../images/customer_1.jpg";
import photo_2 from "../../images/customer_2.jpg";
import photo_3 from "../../images/customer_3.jpg";
import photo_4 from "../../images/customer_4.jpg";
import photo_5 from "../../images/customer_5.jpg";
import photo_6 from "../../images/customer_6.jpg";
import photo_7 from "../../images/customer_7.jpg";
import photo_8 from "../../images/customer_8.jpg";
import photo_9 from "../../images/customer_9.jpg";
import photo_10 from "../../images/customer_10.jpg";


const reviews = [
  {
    id: 1,
    name: 'Игорь Г.',
    text: 'Отличный сервис! Продал авто за пару часов, цена оказалась выше, чем предлагали перекупы. Оплата моментальная, оформление без лишних хлопот. Спасибо!',
    img: photo_1,
    car: 'Mitsubishi Pajero (3.0 MT 2012 г.в.)'
  },
  {
    id: 2,
    name: 'Михаил Б.',
    text: 'Попал в аварию, думал машину только в разбор. Отдал её в ребятам особо ни на что не рассчитывал, но в итоге получил нормальные деньги и остался доволен. Смело могу советовать.',
    img: photo_2,
    car: 'BMW 1 (2.0 MT 2008 г.в.)'
  },
  {
    id: 3,
    name: 'Владислав С.',
    text: 'Огромное спасибо всей команде! Предложили выгодные условия, реально лучше, чем другие. Всё оформили быстро, уже на следующий день машина была на учёте. Удачи вам и побольше клиентов!',
    img: photo_3,
    car: 'Honda Accord (2.4 AT 2013 г.в.)'
  },
  {
    id: 4,
    name: 'Анна Г.',
    text: 'Спасибо большое за отличную работу! Всё прошло супер — и осмотр, и консультация были на уровне. Осталась очень довольна, обязательно порекомендую вас знакомым 😊',
    img: photo_4,
    car: 'Hyundai Getz (1.4 AT 2007 г.в.)'
  },
  {
    id: 5,
    name: 'Дмитрий С.',
    text: 'Хотел продать машину, боялся мороки. Эти ребята все сделали за меня: осмотр, документы, деньги сразу на карту. Очень удобно!',
    img: photo_10,
    car: 'ГАЗ 3221 (2.5 MT 2005 г.в.)'
  },
  {
    id: 6,
    name: 'Владислав П.',
    text: 'Долго не мог найти хороший авто, пока не обратился сюда. Подобрали надежный вариант, провели диагностику, помогли с оформлением. Работают четко!',
    img: photo_5,
    car: 'Kia Sportage (2.0 AT 2011 г.в.)'
  },
  {
    id: 7,
    name: 'Даниил Г.',
    text: 'Сделка прошла на ура. Всё сделали так, как и обещали. Ответили быстро, ждать почти не пришлось. На месте всё подробно объяснили, без лишней суеты. Продажей остался очень доволен.',
    img: photo_6,
    car: 'Audi A6 (2.0 CVT 2014 г.в.)'
  },
  {
    id: 9,
    name: 'Владимир Ш.',
    text: 'Всё чётко и без лишней волокиты. Отдельное спасибо Игорю, всё подробно объяснил, ответил на вопросы, видно, что знает своё дело. Вежливый и приятный в общении, приятно было иметь дело!',
    img: photo_8,
    car: 'ВАЗ 2107 (1.6 MT 2005 г.в.)'
  },
  {
    id: 10,
    name: 'Владимир П.',
    text: 'Подбирали авто под мой бюджет, нашли отличный вариант, даже лучше, чем рассчитывал. Все проверили, оформили быстро. Очень доволен!',
    img: photo_9,
    car: 'Mitsubishi ASX (2.0 CVT 2023 г.в.)'
  },
];

const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div className={styles.slider__button_left}>
      <div className={styles.slider__button} onClick={onClick}>
        <p className={styles.slider__buttonArrow}>❮</p>
      </div>
    </div>
  );
};

const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div className={styles.slider__button_right}>
      <div className={styles.slider__button} onClick={onClick}>
        <p className={styles.slider__buttonArrow}>❯</p>
      </div>
    </div>
  );
};


const ReviewsSection = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    centerMode: false, 
    centerPadding: '0', // Отступы между слайдами
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 900, // Если ширина экрана меньше 1024px
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768, // Если ширина экрана меньше 768px
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className={styles.revSec}>
      <h3 className={styles.revSec__title}>Отзывы клиентов о нашей работе</h3>
      <div className={styles.slider}>
        <Slider {...settings}>
          {reviews.map((review) => (
            <div key={review.id} className={styles.slider__container}>
              <div className={styles.slide}>
                <div className={styles.slide__title}>
                  <p className={styles.slide__name}>{review.name}</p>
                  <img className={styles.slide__photo} src={review.img} alt="" />
                </div>
                <p className={styles.slide__text}>{review.text}</p>
                <div className={styles.slide__ps}>
                  <p className={styles.slide__carInfo}>{review.car}</p>
                  <p className={styles.slide__stars}>★★★★★</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
      <p className={styles.revSec__ps}>Орфография и пунктуация автора сохранены</p>
    </div>
  );
};

export default ReviewsSection;